import { userService } from '../../helpers/easyindustriaapi/user.service';
import { getLoginErrorMessage } from '../../helpers/easyindustriaapi/api-error';
import router from '../../router/index';

function loadCurrentEmpresaFromStorage() {
    try {
        const raw = localStorage.getItem('currentEmpresa');
        if (!raw || raw === 'null') {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && parsed.id) {
            return parsed;
        }
        return null;
    } catch (e) {
        return null;
    }
}

// initial state � hidrata empresa escolhida ap�s refresh
export const state = {
    status: {},
    user: null,
    currentEmpresa: loadCurrentEmpresaFromStorage(),
};

export const mutations = {
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
        state.currentEmpresa = loadCurrentEmpresaFromStorage();
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
        state.currentEmpresa = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
        state.currentEmpresa = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    },
    resetpassWordRequest(state) {
        state.status = { resetpassword: true };
    },
    resetpassWordSuccess(state) {
        state.status = {};
    },
    resetpassWordFailure(state) {
        state.status = {};
    },
    listUsersRequest(state) {
        state.users = null;
        state.status = { listed: true };
    },
    listUsersSuccess(state, users) {
        state.status = {};
        state.users = users;
    },
    listUsersFailure(state) {
        state.status = {};
        state.users = null;
    },
    selectedEmpresaRequest(state) {
        state.status = { loggingIn: true };
    },
    selectedEmpresa(state, currentEmpresa) {
        state.status = {};
        state.status = { loggeduser: true };
        state.currentEmpresa = currentEmpresa;
    },
};

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.user
    },


    isAdmin(state) {
        if (!state.user || !Array.isArray(state.user.roles)) {
            return false;
        }

        return state.user.roles.some(role =>
            ['super', 'partner', 'admin'].includes(role.name)
        );
    }
};

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    loGin({ dispatch, commit }, { email, password }) {
        const promisse = userService.login(email, password);
        return promisse.then(
            user => {
                commit('loginSuccess', user);
                return user;
            },
            error => {
                const message = getLoginErrorMessage(error);

                commit('loginFailure');
                dispatch('notification/error', message, { root: true });
                return Promise.reject(new Error(message));
            }
        );
    },

    // Logout the user
    loGout({ commit }) {
        userService.logout();
        commit('logout');
    },
    resetpassWord({ dispatch, commit }, payload) {
        commit('resetpassWordRequest', payload);
        return userService.resetpassword(payload)
            .then((response) => {
                commit('resetpassWordSuccess');
                return response;
            })
            .catch((error) => {
                commit('resetpassWordFailure');
                const message = (error && error.message) || error;
                dispatch('notification/error', message, { root: true });
                return Promise.reject(error);
            });
    },
    // register the user
    registerUser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        const promisse = userService.register(user);
        return promisse
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Cadastro realizado com sucesso', { root: true });
                    router.push('/userGetAll');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    getAll({ dispatch, commit }, Aid) {
        userService.getAll(Aid)
            .then(
                users => {
                    commit('listUsersSuccess', users);
                    // dispatch('notification/success', 'Lista carregada', { root: true });
                    // router.push('/userGetAll');
                },
                error => {
                    commit('listUsersFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            )
    },
    selectEmpresa({ commit }, Empresa) {
        commit('selectedEmpresaRequest', { Empresa });
        localStorage.setItem('currentEmpresa', JSON.stringify(Empresa));
        commit('selectedEmpresa', Empresa);
    },
};